import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQbrPptxReportIsGeneratingStatus = createSelector(
  [selectQbrState],
  ({ pptxReportState }) => pptxReportState.isGenerating
)
